import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { NavLink } from "react-router-dom";
import "./HomePageCardFor.css";
import cupimg from '../Our Treatments 2/IMG/woman-experiencing-cupping-therapy.jpg'
import Sciatica from '../Our Treatments 2/IMG/full-shot-physiotherapist-helping-patient.jpg'
import ayurvedic from '../Our Treatments 2/IMG/spa-concept-with-woman.jpg'
import deep from '../Our Treatments 2/IMG/closeup-man-having-back-massage-spa-treatment-wellness-center.jpg'
import waxing from '../Our Treatments 2/IMG/laser-epilation-hair-removal-therapy.jpg'

const treatments = [
  {
    path: "/cupping-therapy-treatment",
    title: "Cupping Therapy Treatment",
    description:
      "The cups are used to create suction to draw blood and fluids to the surface...",
      image: cupimg,
  },
  {
    path: "/sciatica-pain-relief-massage",
    title: "Sciatica Pain Relief Massage",
    description:
      "Sciatica causes the most unbearable type of pain that has the potential to...",
      image: Sciatica,

  },
  {
    path: "/ayurvedic-body-massage",
    title: "Ayurvedic Body Massage",
    description:
      "We offer a comprehensive approach to wellness through the ancient richness of Ayurveda...",
      image: ayurvedic,

  },
  {
    path: "/deep-tissue-massage",
    title: "Deep Tissue Massage",
    description: "It is a specialized massage technique that includes using...",
    image: deep,

  },
  {
    path: "/full-body-waxing",
    title: "Waxing Services",
    description:
      "Achieving flawless and hair-free skin is a piece of cake with....",
      image: waxing,

  },
];

const HomePageCardFor = () => {
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    const animationTimer = setTimeout(() => setAnimated(true), 200);
    return () => clearTimeout(animationTimer);
  }, []);

  return (
    <div className="homepage-background">
      <div className="homepage-treatment-wrapper">
        <Container>
          <Row className="text-center mb-2">
            <Col>
              <h1 className="homepage-treatment-header">OUR SERVICES</h1>
            </Col>
          </Row>

          <Row className="homepage-treatment-cards justify-content-center">
            {treatments.map((treatment) => (
              <Col
                lg={3}
                md={6}
                sm={12}
                key={treatment.path}
                className="d-flex justify-content-center"
              >
                <Card
                  className={`homepage-treatment-card ${
                    animated ? "homepage-card-animate" : ""
                  }`}
                  style={{
                    backgroundImage: `url(${treatment.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between">
                    <div>
                      <Card.Title className="homepage-card-title">
                        {treatment.title}
                      </Card.Title>
                    </div>
                    <NavLink
                      to={treatment.path}
                      className="homepage-card-link"
                      aria-label={`Learn more about ${treatment.title}`}
                    >
                      Learn More
                    </NavLink>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default HomePageCardFor;
